import customAxios from '../interceptors';

// current user's session data from the DB plus a fresh JWT ({ user, jwt }, same as login)
const getMe = () => {
  return customAxios.get(`${process.env.REACT_APP_API_URL}/me`)
    .then((res: any) => res.data.data);
}

export default getMe;
